"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../app-reduxs/app/slice"));
const react_1 = require("react");
exports.default = () => {
    const common = () => { };
    const dispatch = (0, react_redux_1.useDispatch)();
    const initAppData = (0, react_1.useCallback)(async () => {
        dispatch(slice_1.default.actions.initDataApp());
    }, []);
    return {
        common,
        initAppData,
    };
};
